<footer class='footer'>
  <div class='main-container'>
    <h2 class='sr-only'>stopka {{ name }}</h2>
    <div class='links' id='footer-links'>
      <a routerLink='/strona-glowna' class='logo'>
        <img [src]='appLogoPath' alt='' width='30' aria-hidden='true'>
        <span class='sr-only'>Strona główna <span class='sr-only'>{{ name }}</span></span> {{ name }}
      </a>
      <ul class="subpages">
        <li><a routerLink='/jak-korzystac'>Jak korzystać</a></li>
        <li><a routerLink='/info/aplikacja-mobilna'>Aplikacja mobilna</a></li>
        <li><a routerLink='/info/o-projekcie'>O projekcie</a></li>
        <li><a routerLink='/info/polityka-prywatnosci'>Polityka prywatności</a></li>
        <li><a routerLink='/info/regulamin'>Regulamin</a></li>
        <li><a routerLink='/info/deklaracja-dostepnosci'>Deklaracja dostępności</a></li>
        <li><a routerLink='/info/kontakt'>Kontakt</a></li>
      </ul>
      <br>
    </div>
    @if (showFooterEULogotypes) {
      <div class='eu-logotypes'>
        <img src='/img/icons/eu/fe-d-dl-pl-right.jpg' alt='Logo Funduszy Europejskich' class='eu-funds-logo'>
        <img src='/img/icons/eu/rp-left-pl.svg'
             alt='biało-czerwona flaga polska obok napis Rzeczpospolita Polska Logotyp'
             class='rp-logo'>
        <img src='/img/icons/eu/eu-efrp-left-pl.jpg' alt='Logotyp Unii Europejskiej'>
        <img src="/img/icons/eu/dolny_slask.jpg" style="height: 2.65rem" class='eu-logo-left' alt="Logotyp Dolny Śląsk">
        <img src="/img/icons/eu/dolny_slask.jpg" style="height: 2.65rem" class='eu-logo-right'
             alt="Logotyp Dolny Śląsk">
      </div>
    }
    <div>
      <small>
        Zadanie zrealizowane w ramach projektu nr FEDS.01.03-IZ.00-0004/23 pn.: „Cyfryzacja usług publicznych w gminie Długołęka” dofinansowanego ze środków Europejskiego Funduszu Rozwoju Regionalnego w ramach Programu Fundusze Europejskie dla Dolnego Śląska 2021-2027.
      </small>
    </div>
  </div>
</footer>
<div class='appVersion'>Version: {{ version }} <span *ngIf="!production" class="color--dark-red">&nbsp;(dev mode)</span></div>
